module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("member_oneclick_upgrade", [["div",{"class":"popup-title-wrapper"},[["h3",{"class":"popup-title"},[["textNode",{"text":"Thank you"}]]],["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"popup-content-wrapper"},[["textNode",{"text":" THE UPGRADE WAS SUCCESSFUL, ENJOY! "}]]],["div",{"class":"popup-footer-wrapper"},[["button",{"id":"close","class":"mc-common-button close"},[["textNode",{"text":"Close"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/templates/oneclick-upgrade.tpl
// module id = 803
// module chunks = 4